<script src="../../containers/admin-subscription-list/admin-subscription-list.component.ts"></script>
@let modelData = model();
@let columnData = column();

@switch (columnData.key) {
  @case (getColumnKey('status')) {
    <app-subscription-status [status]="modelData.status" />
  }

  @case (getColumnKey('totalPrice')) {
    <div class="flex gap-1">
      <app-currency [amount]="modelData.totalPrice" />
      <span>/</span>
      <span>miesiąc</span>
    </div>
  }

  @case (getColumnKey('cardNumber')) {
    <div class="flex flex-col text-center text-sm">
      @if (isNotNil(modelData.cardNumber)) {
        <div>{{ modelData.cardNumber }}</div>
      } @else {
        <app-no-data />
      }

      <div>---</div>

      @if (isNotNil(modelData.cardExpiryDate)) {
        <div>{{ modelData.cardExpiryDate }}</div>
      } @else {
        <app-no-data />
      }
    </div>
  }

  @case (getColumnKey('subscriber')) {
    <div class="flex gap-1">
      {{ modelData.subscriber.dignity }}
    </div>
  }

  @case (getColumnKey('nextPaymentDate')) {
    @if (isNotNil(modelData.nextPaymentDate)) {
      <div>
        <app-date [date]="modelData.nextPaymentDate" />
      </div>
    }

    @if (isNotNil(modelData.secondPaymentDate)) {
      <div class="text-sm text-gray-500">
        <app-date [date]="modelData.secondPaymentDate" />
      </div>
    }

    @if (isNotNil(modelData.thirdPaymentDate)) {
      <div class="text-xs text-gray-400">
        <app-date [date]="modelData.thirdPaymentDate" />
      </div>
    }
  }

  @default {
    <app-table-body-no-reference-cell [columnKey]="columnData.key" />
  }
}
